import React, { useContext } from 'react';
import { ExplorerContext } from '../../application/config';
import { useMap } from 'react-leaflet';
import { IonFab, IonFabButton, IonIcon } from '@ionic/react';
import { locate } from 'ionicons/icons';

export default function MapHomeButton() {
	const AppData = useContext(ExplorerContext);
	const map = useMap();
	const flyCurrent = () => {};

	return (
		<IonFab slot="fixed" vertical="top" horizontal="end">
			<IonFabButton>
				<IonIcon
					onClick={() => {
						console.log('Fly me to ', AppData.current_location);
						map.flyTo(AppData.current_location);
					}}
					icon={locate}></IonIcon>
			</IonFabButton>
		</IonFab>
	);
}
